import {
  all,
  fork,
} from 'redux-saga/effects';

import initialize from './initialize';
import uploadFlow from './upload';
import downloadFlow from './download';
import watchingTasks from './watchingTasks';

export default function* rootSaga() {
  yield all([
    fork(initialize),
    fork(uploadFlow),
    fork(downloadFlow),
    fork(watchingTasks),
  ]);
}
